import { Pipe, PipeTransform } from '@angular/core';
import { Store } from '@ngxs/store';
import { FeatureEnum } from '../../samwebDescription/samwin/FeatureEnum';
import { Observable } from 'rxjs';
import { EnabledFeaturesState } from '../../store/session/enabled-features/enabled-features.state';
import _ from 'lodash';

@Pipe({
   name: 'isFeatureEnabled$',
})
export class IsFeatureEnabledPipe implements PipeTransform {
   constructor(private store: Store) {}

   transform(value: FeatureEnum | string): Observable<boolean> {
      let feature: FeatureEnum;
      if (_.isString(value)) {
         feature = FeatureEnum.valueOf(value);
      } else {
         feature = value;
      }
      return this.store.select(EnabledFeaturesState.isFeatureEnabled(feature));
   }
}
